<template>
  <div id="app" style="">
      <loading-bar
      id="global_loading_bar"
      custom-class="custom-class"
      :on-error-done="errorDone"
      :on-progress-done="progressDone"
      :progress="loadingbar.progress"
      :direction="loadingbar.direction"
      :error="loadingbar.error" >
    </loading-bar>
    <back-to-top text="回到顶部"></back-to-top>
    <router-view name="header"></router-view>
    <transition name="outIn">
      <router-view v-show="show" name="chart"></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import LoadingBar from 'vue2-loading-bar'
import BackToTop from 'vue-backtotop'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  data () {
      return {
        show:true,
        transitionName: 'expand',
        loadingbar: {
          progress: 0,
          error: false,
          direction: 'right'
        }
      }
    },
    // provide:function(){
    //   return {
    //     getNum:function(){
    //       alert("1234466778899");
    //     }
    //   }
    // },
    components: {
      LoadingBar: LoadingBar, BackToTop
    },
    computed: {
      ...mapState({
        loading: state => state.global.loading
      })
    },
    watch: {
      'loading': function(val, old) {
        if (val == true) {
          this.loadingbar.progress = 10;
        } else {
          setTimeout(() => {
            this.loadingbar.progress = 100;
          }, 200);
        }
      },
      'showDialog':function(){
        this.showDialog = false;
      }
    },
    mounted: function () {
      // let token = this.$route.query.token;
      var me = this;
      me.loadingbar.progress = 10;
      for (var i = 0; i < 30; i++) {
        if(i > 20 && i < 29){
          setTimeout(function () {
            me.loadingbar.progress += 5;
          },50*i);
        }else{
          setTimeout(function () {
            me.loadingbar.progress ++;
          },10*i);
        }
      }
      setTimeout(function () {
        me.loadingbar.progress = 100;
      },1500);
    },
    methods:{
      getToken:function (){

      },
      progressTo: function (val) {
        this.loadingbar.progress = val;
      },
      setToError: function (bol) {
        this.loadingbar.error = bol;
      },
      changeDirection: function (direction) {
        if(this.loadingbar.progress >= 0){
          this.loadingbar.progress = 100;
        }
        this.loadingbar.direction = this.loadingbar.direction === 'right' ? 'left' : 'right';
      },
      errorDone(){
        this.loadingbar.error = false
      },
      progressDone() {
        this.loadingbar.progress = 0
      }
    }
}
</script>

<style>   
    @import 'vue2-loading-bar/src/css/app.css';
    @import 'vue2-loading-bar/src/css/loading-bar.css';
    @import './assets/css/base.css';
    @import './assets/css/common.css';
    @import "./assets/icon/iconfont.css";
.outIn-enter-active {
      transition: all 0.2s ease-in;
   }
   .outIn-leave-active {
      transition: all 0.2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
   }
   .outIn-enter, .outIn-leave-to{
      transform: translateX(5rem);
      opacity: 0;
   }
    #app, body, html {
        height: 100%;
        min-width:1366px;
        min-height:800px;
        background-color:#fff;
    }

    .content-wrap {
        width:100%;
        position: absolute;
        top: 80px;
        height:calc(100% - 80px );
        padding-top:30px;
        z-index:22;
        background-color:#fff;
        
        background-size:cover;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue